import React from 'react';

/**
 * Is the nav sitting on a dark surface right now?
 *
 * Nearly everything in the header takes its colour from CSS custom properties,
 * so a `data-theme="dark"` attribute on a wrapper re-themes the whole subtree
 * for free. The exceptions are the handful of icons picked in JS, which have
 * separate light and dark artwork and would otherwise stay on the light cut
 * while the surface behind them went dark.
 *
 * This is deliberately not the theme. The landing page forces a dark bar over
 * the reel regardless of which theme the visitor chose, and the theme selector
 * in that same bar still has to report and toggle the real one.
 */
const DarkSurfaceContext = React.createContext(false);

export const DarkSurfaceProvider = DarkSurfaceContext.Provider;

export const useDarkSurface = () => React.useContext(DarkSurfaceContext);
